// extracted by mini-css-extract-plugin
export default {"switchableInput":"switchableInput__z5U0OO"};